import React from 'react';
import core from '@gin-betting/core';

import { BettingWidgets } from 'app-constants';
import { Widget } from 'components';
import { useWidgetSettings } from 'hooks';
import SettingsButtonMobile from './SettingsButtonMobile';

import './headerMobile.scss';

const { getBettingOptions } = core.utils;

const HeaderMobile: React.FC = () => {
    const { isAuthorized } = getBettingOptions();

    const { isSettingsEnabled } = useWidgetSettings({
        widget: BettingWidgets.MOBILE_HEADER,
    });

    if (!isAuthorized) return null;

    return (
        <Widget
            widget={BettingWidgets.MOBILE_HEADER}
            replacePortalContent={true}
        >
            <div styleName="container">
                {isSettingsEnabled && <SettingsButtonMobile />}
            </div>
        </Widget>
    );
};

export default React.memo(HeaderMobile);
